import {
  EventEmitter,
  Injectable,
  signal,
  WritableSignal,
} from '@angular/core';
import { OnInteraction } from './models/on-interaction/on-interaction.model';
import { Mode } from './shared/enums/mode.enum';

@Injectable({
  providedIn: 'root',
})
export class AlfredClientService {
  /**
   * Flag which determines in which mode the component is running.
   */
  public readonly mode: WritableSignal<Mode> = signal(Mode.API);

  /**
   * Flag that allows the parent app to hide the close button
   * while filling in a questionnaire.
   */
  public readonly showCloseButton: WritableSignal<boolean> = signal(true);

  /**
   * Flag that allows the parent app to disable the close confirmation of the questionnaire.
   *
   * When this property is called the client will only call the {@see onCancelClick} and
   * {@see finished}.
   */
  public readonly showCloseConfirmation: WritableSignal<boolean> = signal(true);

  /**
   * Event emitted by the thank-you page.
   */
  public finished: EventEmitter<void> = new EventEmitter<void>();

  /**
   * Event which triggers when the event button is triggered
   */
  public onNextClick: EventEmitter<OnInteraction | undefined> =
    new EventEmitter<OnInteraction | undefined>();

  /**
   * Event which triggers when the event button is triggered
   */
  public onPreviousClick: EventEmitter<OnInteraction | undefined> =
    new EventEmitter<OnInteraction | undefined>();

  /**
   * Event which triggers when the cancel button it trigger and the users
   * continued after the warning dialog.
   */
  public onCancelClick: EventEmitter<void> = new EventEmitter<void>();

  /**
   * emits {@see self.finished}
   */
  public finish(): void {
    this.finished.emit();
  }

  /**
   * emits {@see self.onNextClick}
   */
  public next(nextStep?: OnInteraction): void {
    this.onNextClick.emit(nextStep);
  }

  /**
   * emits {@see self.onPreviousClick}
   */
  public previous(previousStep?: OnInteraction): void {
    this.onPreviousClick.emit(previousStep);
  }

  /**
   * emits {@see self.onCancelClick}
   */
  public cancel(): void {
    this.onCancelClick.emit();
  }

  /**
   * Returns true if in api mode
   */
  public isApiMode(): boolean {
    return this.mode() === Mode.API;
  }

  /**
   * Returns true if in direct handle mode
   */
  public isDirectHandleMode(): boolean {
    return this.mode() === Mode.DIRECT_HANDLE;
  }
}
